import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import { useSnackbar } from 'notistack';
import { useState } from 'react'
import { updateLeaseStatusApi } from '../apiServices';
import { checkApiStatus } from '../../../utils';
import { globalPostService } from '../../../utils/globalApiServices';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { trackActivity } from '../../../utils/mixpanel';
import { backendDateFormat, fieldDateFormat } from '../../../constants';

const LeaseChangeStatus = ({ changeStatusLeases, onToggleModal, params, setChangeStatusLeases, getList }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [status, setStatus] = useState(() => { const initLabel = changeStatusLeases?.status || (changeStatusLeases?.data?.status ? changeStatusLeases.data.status : ""); return { ...changeStatusLeases.data, status: initLabel, reason: changeStatusLeases.data?.reason, closure_date: changeStatusLeases.data?.closure_date }; });
  const statusLabel = [{ id: "draft", Label: "Draft" }, { id: "active", Label: "Active" }, { id: "closed", Label: "Closed" }, { id: "terminated", Label: "Terminated" }, { id: "on-hold", Label: "On-hold" }]



  const onFieldChange = (key, e) => {
    if (key === "status") {
      const selectedId = e.target.value;
      const selectedLabel =
        statusLabel.find((s) => s.id === selectedId)?.Label || "";
      setStatus({ ...status, [key]: selectedLabel,reason :"" });
    } else {
      setStatus({ ...status, [key]: e.target.value });
    }
    setError({ ...error, [key]: "" });
  };
  const handleLeaseStatusChange = () => {
    let validationInputs = {};
    validationInputs = {
      ...validationInputs,
      status: status?.status ? "" : "Please select Lease Status",
      closure_date:
        status?.status === "Terminated"
          ? status?.closure_date
            ? ""
            : "Please Select Closure Date"
          : "", // no error if not Terminated
      reason: status?.reason?.trim()?.length ? "" : "Please enter Reason",
    };
    if (
      Object.keys(validationInputs).every((k) => {
        return validationInputs[k] === "";
      })
    ) {
      const payload = { status: status?.status, user: 2, reason: status?.reason, lease: status?.lease, closure_date: status?.closure_date };
      setLoading(true);
      if (status.id) {
        globalPostService(updateLeaseStatusApi({ ...params, asset_type: status?.asset_type, asset_slug: status?.asset_slug, leaseSlug: status?.leaseSlug, lessor_id: status?.lessor_id?.id }), payload)
          .then((response) => {
            if (checkApiStatus(response)) {
              enqueueSnackbar(response?.data?.message, {
                variant: "success",
                anchorOrigin: { horizontal: "right", vertical: "top" },
              });
              onToggleModal();
              setChangeStatusLeases();
              getList()
              trackActivity('Item Edited', { page_title: `Edit Lease Status Change`, success_msg: response?.data?.message, item_id: status?.id, payload: status, response: response?.data })
            } else {
              //toast message
              enqueueSnackbar(response.data.message, {
                variant: "error",
                anchorOrigin: { horizontal: "right", vertical: "top" },
              });
            trackActivity('Item Edited', { page_title: `Edit Lease Status Change`, error_msg: response?.data?.message, item_id: status?.id, payload: status, response: response?.data })
            }
            setLoading(false);
          });
      }
    } else {
      setError(validationInputs);
      trackActivity(`Item Edited`, { page_title: `Lease Status Change`, error_msg: validationInputs, })
    }
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Lease Status Change`, page_type: page_type, })
  }

  return (
    <Dialog aria-labelledby="customized-dialog-title"
      className='add-lease-dialog'
      open={changeStatusLeases?.modal}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
      <Typography sx={{marginLeft: "10px"}}> {"Lease Status"} </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid size={{ md: 12, xs: 12, }} mt={2}>
            <Autocomplete
              disablePortal
              disableClearable
              fullWidth
              options={status.status==='Draft'? statusLabel:statusLabel.filter(item=>item.id!=='draft')}
              getOptionLabel={(option) => option.Label || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={statusLabel.find((option) => option.Label === status.status) || null}
              onChange={(e, newValue) => {
                setStatus((prev) => ({
                  ...prev,
                  status: newValue?.Label || "",
                  reason:changeStatusLeases?.data?.status === newValue?.Label ? changeStatusLeases?.data?.reason : ""
                }));
                setError((prev) => ({ ...prev, status: "" }));
              }}
              slotProps={{
                listbox: { style: { maxHeight: 140 } }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Lease Status"
                  margin="normal"
                  size="small"
                  fullWidth
                  error={Boolean(error.status)}
                  helperText={error.status}
                  slotProps={{ inputLabel: { shrink: true } }}
                />
              )}
              disabled={isLoading}
            />

          </Grid>
          {
            status?.status === "Terminated" && <Grid size={{ md: 12, xs: 12, }}>
              <LocalizationProvider dateAdapter={AdapterMoment} >
                <DatePicker
                  label="Closure Date"
                  value={status?.closure_date ? moment(status.closure_date) : null}
                  onChange={(newDate) => {
                    setStatus(prev => ({
                      ...prev,
                      closure_date: moment(newDate).format(backendDateFormat),
                    }));
                    setError(prev => ({ ...prev, closure_date: "" }));
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      InputLabelProps: { shrink: true, required: true },
                      size: "small",
                      margin: "normal",
                      minWidth: 0,
                      fullWidth: true,
                      helperText: error.closure_date,
                      error: error.closure_date,

                    },
                  }}
                  format={fieldDateFormat}
                  disabled={isLoading}
                />
              </LocalizationProvider>
            </Grid>
          }


          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              required
              label="Reason of Status Change"
              variant="outlined"
              size="small"
              margin="normal"
              slotProps={{ inputLabel: { shrink: true } }}
              value={status?.reason || ""}
              onChange={(e) => {
                const val = e?.target?.value;
                if (val.length <= 250) {
                  onFieldChange("reason", e);
                  setError({ ...error, reason: "" });
                }
              }}
              onPaste={(e) => {
                const pasted = e.clipboardData.getData("text");
                if (pasted.length > 250) {
                  e.preventDefault();
                }
              }}
              error={!!error.reason}
              helperText={
                error.reason ||
                (status?.reason?.length > 250
                  ? "Maximum 250 characters allowed"
                  : "")
              }
              fullWidth
              multiline
              rows={3}
              disabled={isLoading}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ marginRight: "15px" }}>
        <Button className="cancel-btn" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} size='small' variant='outlined'>Cancel</Button>
        <Button variant='contained' size='small' onClick={() => { handleItemClicked('Save Button'); handleLeaseStatusChange() }} >{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default LeaseChangeStatus